import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/@core/services/app.service';
import { MarketplaceService } from 'src/@core/services/marketplace.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.scss']
})
export class MarketplaceComponent implements OnInit {
  selectedTabIndex: any;
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;
  pageSizeOptions: number[] = [20, 50, 100, 500];
  profile = this.appService.getCurrentAccount();
  searchParams = [];
  marketPlacesList: any[] = [];
  baseImageUrl = environment.image_url;

  constructor(
    private router: Router,
    public appService: AppService,
    public marketplaceService: MarketplaceService
  ) { }

  ngOnInit() {
    console.log("calll MarketplaceComponent")
    this.getAllMarketPlaces();
  }

  getAllMarketPlaces() {
    // const entityId = this.profile.entity.id;

    this.marketplaceService.getAllMarketPlaces(
      // entityId,
      this.pageIndex,
      this.pageSize,
      'createdOn',
      'desc',
      this.searchParams
    ).subscribe(res => {
      this.marketPlacesList = res.content;
      this.resultsLength = res.totalElements;
    }, (err => {

    }))

  }

  onPaginateChange(event) {
    this.pageIndex = event.pageIndex;
    this.getAllMarketPlaces();
  }

  viewProfile(portfolio) {
    this.router.navigateByUrl('/marketplace/view-marketplace/' + portfolio.id);
  }

  // openCreateForm() {
  //   this.router.navigate(['/digital-portfolio/form']);
  // }

  onTabChanged(event) {

  }

  markAsFavourite(portfolio) {

  }
}
